import { isNotNil } from "./guards";

export function setIfNotNil<T>(
  setter: (value: T) => void,
  value: T | null | undefined,
) {
  if (isNotNil(value)) {
    setter(value);
  }
}
